(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ReportingPaiement', ReportingPaiement);

    ReportingPaiement.$inject = ['$resource'];

    function ReportingPaiement ($resource) {
        var resourceUrl =  'api/reporting-paiement/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'downloadCsvPayments': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/reporting-agence/download-payment',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            },
            'downloadCsvReceipts': {
                method: 'GET',
                headers: {
                    accept: 'text/csv'
                },
                responseType: 'arraybuffer',
              	url :'/api/reporting-agence/download-receipt',
                transformResponse: function (data,headers) {
                	  var filename = headers('FileName');
                	  var contentType = headers('ContentType');
                    var csv;
                    if (data) {
                        csv = new Blob([data], {
                            type: contentType
                        });
                    }
                    return {
                        response: csv,
                        fileName : filename,
                        contentType : contentType
                    };
                }
            }
            
            
            
        });
        
    }
})();
